export default __webpack_public_path__ + "static/media/formas-digitales-nosotros-mision.de901a47.png";